import { getToken } from "./auth";

const API_BASE = "https://ohms.gbu.ac.in/api/index.php?route=student_hostels";

// Fetch programmes (for first-year students)
export async function getAvailableProgrammes() {
  const token = getToken();
  const res = await fetch(API_BASE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify({ action: "getAvailableProgrammes" }),
  });
  return res.json();
}

// Fetch hostels for existing students (based on roll number)
export async function getAvailableHostels() {
  const token = getToken();
  const res = await fetch(API_BASE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify({ action: "getAvailableHostels" }),
  });
  return res.json();
}

// Fetch hostels by programme (for first-year students)
export async function getHostelsByProgramme(programmeId) {
  const token = getToken();
  const res = await fetch(API_BASE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify({
      action: "getHostelsByProgramme",
      programmeId
    }),
  });
  return res.json();
}

// Fetch floors of selected hostel
export async function getFloors(hostelId) {
  const token = getToken();
  const res = await fetch(API_BASE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify({ action: "getFloors", hostelId }),
  });
  return res.json();
}

// Fetch rooms of selected floor/hostel
export async function getRooms(hostelId, floorId, seater) {
  const token = getToken();
  const res = await fetch(API_BASE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify({ 
      action: "getRooms", 
      hostelId, 
      floorId, 
      seater 
    }),
  });
  return res.json();
}

// Allowed hostels
export async function getAllowedHostels() {
  const token = getToken();
  const res = await fetch(API_BASE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify({ action: "getAllowedHostels" })
  });
  return res.json();
}

// 🔹 Submit single seater upgrade request
export async function submitSingleSeaterRequest() {
  const token = getToken();
  const res = await fetch(API_BASE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify({ action: "requestSingleSeater" }),
  });
  return res.json();
}

// 🔹 Get status of existing single seater request
export async function getSingleSeaterRequestStatus() {
  const token = getToken();
  const res = await fetch(API_BASE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify({ action: "getSingleSeaterRequestStatus" }),
  });
  return res.json();
}


// 🔹 Get blank fields that need to be filled
export async function getBlankFields() {
  const token = getToken();
  const res = await fetch(API_BASE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify({ action: "getBlankFields" }),
  });
  return res.json();
}

export async function bookRoom(hostelId, roomId) {
  const res = await fetch(API_BASE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getToken()
    },
    body: JSON.stringify({ action: "bookRoom", hostelId, roomId })
  });

  const text = await res.text();
try {
  return JSON.parse(text.trim());
} catch (err) {
  console.error("Invalid JSON response from server:\n", text);
  return { success: false, error: "Invalid JSON response from server." };
}

}
